import { createStore } from "owa-satcheljs";

export interface CalendarSchedulingDialogStoreSchema {
    isOpen: boolean;
}

const store: CalendarSchedulingDialogStoreSchema = {
    isOpen: false,
};

export const getStore: () => CalendarSchedulingDialogStoreSchema = createStore<CalendarSchedulingDialogStoreSchema>("CalendarSchedulingDialogStore", store);
